export default "__VITE_ASSET__nA7XVUbC__"